import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@lr/core';


@Component({
  selector: 'lr-logout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
    private authService = inject(AuthService);
  
    ngOnInit(): void {
      console.log('Logout: Auto-triggering logout immediately');
      this.authService.logout();
    }
  }